import {createStore} from "@stencil/store";

type DummyData = {
	userId: number;
	id: number;
	title: string;
	completed: boolean;
};

const {state, onChange} = createStore({
	isLoading: false,
	assets: [] as DummyData[],
});

async function loadAssets() {
	console.log("start loadAssets");
	state.isLoading = true;

	const response = await fetch("https://jsonplaceholder.typicode.com/todos");
	const data = (await response.json()) as DummyData[];
	state.assets = data;

	state.isLoading = false;
	console.log("end loadAssets", state.assets);
}

void (async () => {
	await loadAssets().catch((error) => console.error("Error in loadAssets:", error));
})();

export {state as clStore, onChange};
